import clsx from 'clsx'
import { ClassNameValue, twMerge } from 'tailwind-merge'

export function cn(...classNames: clsx.ClassValue[]) {
  return twMerge(clsx(classNames))
}
